// extracted by mini-css-extract-plugin
export default {"buttonGithub":"GitHub_buttonGithub__vZDhz","buttonGithubImg":"GitHub_buttonGithubImg__-jyoa"};